import { Company, Employee } from "../../types";
import styled from "styled-components";
import { Typography } from "@mui/material";
import { Palette } from "lucide-react";
import { theme } from "../../theme";

type Props = {
    employee?: Employee;
    company?: Company;
};

export const EmployeeInfo = (props: Props) => {
    return (
        <EmployeeInfoWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Company:
                </Typography>
                <Typography sx={sxPoppins} fontSize={18} fontWeight={"600"}>
                    {props.company?.name}
                </Typography>
            </RowWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Email:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.email}
                </Typography>
            </RowWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Name:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.name}
                </Typography>
            </RowWrapper>
            <RowWrapper>
                <Typography sx={sxPoppins} fontWeight={600} fontSize={18} color="#8c8c8c">
                    Role:
                </Typography>
                <Typography sx={sx} fontSize={16} fontWeight="400">
                    {props.employee?.role}
                </Typography>
            </RowWrapper>
        </EmployeeInfoWrapper>
    );
};

const EmployeeInfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    gap: 1rem;
`;

const RowWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    h6:first-child {
        max-width: 150px;
        width: 100%;
        color: #8c8c8c;
    }
    #8C8C8C h6:nth-child(2) {
        display: flex;
        flex-shrink: 1;
        word-break: break-all;
    }
`;
const sx = {
    fontFamily: "'Yllw Sans a1 241219', sans-serif",
};
const sxPoppins = { fontFamily: "'Poppins', sans-serif" };
